
export const Card = ({ title, children }) => (
  <div className="bg-white rounded-xl shadow-sm border p-6 space-y-4">
    <h4 className="font-semibold text-lg">{title}</h4>
    {children}
  </div>
);
